const pathMapping = {
    '/': { name: 'top', section: 'top' },
    '/personal-information': { name: 'profile_info', section: 'profile' },
    '/account-security': { name: 'profile_security', section: 'profile' },
    '/account-security/delete': {
        name: 'profile_cancel_membership',
        section: 'cancel_membership',
    },
    '/points-club': { name: 'profile_points', section: 'profile' },
    '/services': { name: 'profile_services', section: 'profile' },
    '/payments': { name: 'profile_payments', section: 'payments' },
    '/addresses': { name: 'profile_addresses', section: 'addresses' },
    '/addresses/jp': { name: 'profile_addresses_jp', section: 'addresses_jp' },
    '/profile': { name: 'top', section: 'top' },
    '/profile/': { name: 'top', section: 'top' },
    '/profile/personal-information': { name: 'profile_info', section: 'profile' },
    '/profile/account-security': { name: 'profile_security', section: 'profile' },
    '/profile/account-security/delete': {
        name: 'profile_cancel_membership',
        section: 'cancel_membership',
    },
    '/profile/points-club': { name: 'profile_points', section: 'profile' },
    '/profile/services': { name: 'profile_services', section: 'profile' },
    '/profile/payments': { name: 'profile_payments', section: 'payments' },
    '/profile/addresses': { name: 'profile_addresses', section: 'addresses' },
    '/profile/addresses/jp': { name: 'profile_addresses_jp', section: 'addresses_jp' },
    '/cashback-and-rewards': { name: 'profile_cashback_and_rewards', section: 'profile' },
    '/services-privacy': { name: 'profile_services_privacy', section: 'ucrm' },
    '/about': { name: 'profile_about_page', section: 'profile' },
    '/ekyc': { name: 'profile_ekyc', section: 'ekyc' },
    '/social-account-linkage-management': {
        name: 'profile_linked_accounts',
        section: 'linked_accounts',
    },
};

export default pathMapping;
